import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {Utils} from '../../../../../../common/services/Utils';
import {DictionaryService} from '../../../../services/dictionary.service';
import {ProfessionTypeService} from '../../../../../../common_services/profession-type.service';
import {ModuleENUM} from '../../../../../../common/enums/module.enum';
import {ModuleExtendedEdit} from '../../../../../../common/enums/module-extended-edit.enum';
import {Principal} from '../../../../../../common/services/principal';

@Component({
  selector: 'app-direction-of-speciality-edit-modal',
  templateUrl: './direction-of-speciality-edit-modal.component.html',
  styleUrls: ['./direction-of-speciality-edit-modal.component.scss']
})
export class DirectionOfSpecialityEditModalComponent implements OnInit {
  dicDto = null;
  educatedList = [];
  professionTypeList = [];
  professionTypeSpecialIdList = [1, 2, 3]; //
  hasWriteAccess = false;

  constructor(public _dialogRef: MatDialogRef<DirectionOfSpecialityEditModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private _utils: Utils,
              private _dialog: MatDialog,
              private _professionTypeService: ProfessionTypeService,
              private _principal: Principal,
              private _dictionaryService: DictionaryService) {

    if (data && data.educated) {
      data.educatedId = data.educated.id;
    }
    if (data && data.professionType) {
      data.professionTypeId = data.professionType.id;
    }
    this.dicDto = Object.assign({}, data);

    this.hasWriteAccess = this._principal.isAdmin() ||
      (this._principal.hasWriteAccess(ModuleENUM.DICTIONARY) && this._principal.hasModuleExtendedEdit(ModuleENUM.DICTIONARY, ModuleExtendedEdit.DATA_EDIT));
  }

  ngOnInit() {

    this._professionTypeService.getAll().subscribe(list => {
        this.professionTypeList = list;
      }
    );

    this._dictionaryService.getDicEducatedList().subscribe(list => {
        this.educatedList = list;
      }
    );
  }


  onSubmit() {
    const selectedType = this.professionTypeList.filter(e => e.id === this.dicDto.professionTypeId);
    if (!selectedType || !selectedType.length) {
      this._utils.notifyError('name', null);
      return;
    }
    this.dicDto.professionType = selectedType[0];

    const selectedEducated = this.educatedList.filter(e => e.id === this.dicDto.educatedId);
    if (!selectedEducated || !selectedEducated.length) {
      this._utils.notifyError('student.educated', null);
      return;
    }
    this.dicDto.educated = selectedEducated[0];

    const val = this.getMinScoreValue();
    if (this.dicDto.minTotalPoints < val || !val || !this.dicDto.minTotalPoints) {
      this._utils.notifyError('Минимальное общее количество баллов для поступления ' + this.dicDto.professionType.nameRu + ' = ' + val, null);
      return;
    }

    this._dictionaryService.saveDicDirectionOfSpecialty(this.dicDto).subscribe(
      (data) => {
        this._utils.notifySuccess('common.saved_successfully', null);
        this._dialogRef.close(true);
      },
      error => {
        if (error.status == 409) {
          this._utils.notifyError('Запись уже существует', [this.dicDto.professionType.nameRu, this.dicDto.educated.nameRu]);
        } else {
          this._utils.notifyError('error_occurred', null);
        }
        console.log(error);
      }
    );
  }

  getMinScoreValue() {
    const educated = this.dicDto.educatedId;
    const pt = this.dicDto.professionTypeId;
    if (educated == 1) {
      if (this.professionTypeSpecialIdList.includes(pt)) {
        return 25;
      } else {
        return 20;
      }
    } else if (educated == 2) {
      if (this.professionTypeSpecialIdList.includes(pt)) {
        return 35;
      } else {
        return 30;
      }
    }
    return null;
  }

  changeValue() {
    if (!this.dicDto.minTotalPoints) {
      this.dicDto.minTotalPoints = this.getMinScoreValue();
    }
  }

  close(): void {
    this._dialogRef.close(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/dictionary/direction-of-speciality-list/direction-of-speciality-edit-modal/direction-of-speciality-edit-modal.component.ts